import styled, { css } from 'styled-components'
import Link from 'next/link'

import { LinkProps } from './Link'

const duration = '0.33s'
const timing = 'ease-in-out'

const sizeStyles = ({ size }: LinkProps) => {
  switch (size) {
    case 'large':
      return css<LinkProps>`
        font-size: ${({ theme: { fontSize } }) => fontSize.large};
        ${({ icon }) =>
          icon
            ? css`
                padding-left: 40px;
                line-height: ${({ theme: { layout } }) => layout.spacing(4)};
              `
            : null};
      `
    case 'small':
      return css<LinkProps>`
        font-size: ${({ theme: { fontSize } }) => fontSize.small};
        ${({ icon }) =>
          icon
            ? css`
                padding-left: 28px;
                line-height: 20px;
              `
            : null};
      `
    case 'medium':
    default:
      return css<LinkProps>`
        ${({ icon }) =>
          icon
            ? css`
                padding-left: ${({ theme: { layout } }) => layout.spacing(4)};
                line-height: ${({ theme: { layout } }) => layout.spacing(3)};
              `
            : null};
      `
  }
}

export const SvgWrapper = styled.span<Pick<LinkProps, 'size'>>`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  ${({ size }) => {
    switch (size) {
      case 'large':
        return css`
          height: ${({ theme: { layout } }) => layout.spacing(4)};
        `
      case 'small':
        return css`
          height: 20px;
        `
      case 'medium':
      default:
        return css`
          height: ${({ theme: { layout } }) => layout.spacing(3)};
        `
    }
  }};

  svg {
    width: auto;
    height: 100%;
  }
`

export const StyledLink = styled(Link)<LinkProps>`
  position: relative;
  color: ${({ theme: { link } }) => link.color};
  transition: color ${duration} ${timing};
  ${sizeStyles}

  &:hover {
    color: ${({ theme: { link } }) => link.hover.color};
  }
`
